import { render, staticRenderFns } from "./Medecins.vue?vue&type=template&id=22c6628c&scoped=true&"
import script from "./Medecins.vue?vue&type=script&lang=js&"
export * from "./Medecins.vue?vue&type=script&lang=js&"
import style0 from "./Medecins.vue?vue&type=style&index=0&id=22c6628c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6628c",
  null
  
)

export default component.exports